import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export const SubscriptionModal = ({ showSubscriptionModal, handleClose, navigateUrl }) => {
    const navigate = useNavigate();
    return (
        <Modal
          show={showSubscriptionModal}
          backdrop="static"
          centered
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Subscription required</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Please purchase a subscription to watch this video.
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => navigate(navigateUrl)} // Wrap in arrow function
            >
              Go to Quests
            </Button>
          </Modal.Footer>
        </Modal>
    )
}